export const COURSE_PRICE = 25;
